import { useEffect, useLayoutEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { PAGE_NOT_FOUND } from "../../../constants";
import useAppPersistence from "../../../hooks/persistence/useAppPersistence";

const usePageNotFoundData = () => {
  const history = useHistory();
  const location = useLocation();
  const { setCurrentResourceScreen } = useAppPersistence();

  useLayoutEffect(() => {
    // If user navigates manually to `/not-found` path, will redirect to home path
    if (location.pathname === PAGE_NOT_FOUND && !location.state) {
      history.replace("/");
    }
  }, [location.state, history, location]);

  useEffect(() => {
    // Reset current page persistence
    const params = new URLSearchParams(location?.search);
    const resource = params.get("resource");

    const page = resource?.split("/")?.[0];

    setCurrentResourceScreen(page, "");
  }, [location?.search, setCurrentResourceScreen]);

  const navigateBack = () => {
    history.goBack();
  };

  return { navigateBack };
};

export default usePageNotFoundData;
